/* ============================================================
   Scooterride Magic — Hero Wipe-Down Trigger
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function initHeroReveal() {
    const heroes = document.querySelectorAll('.hero:not([data-sr-hero-init])');
    if (!heroes.length) return;

    const supportsIO = 'IntersectionObserver' in window;

    if (!supportsIO) {
      heroes.forEach((h) => {
        h.setAttribute('data-sr-hero-init', '1');
        h.classList.add('sr-hero-revealed');
      });
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        // Trigger sobald Hero zu 15% sichtbar ist
        if (e.intersectionRatio >= 0.15) {
          e.target.classList.add('sr-hero-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: [0, 0.05, 0.15, 0.3, 0.5] });

    heroes.forEach((h) => {
      h.setAttribute('data-sr-hero-init', '1');
      io.observe(h);
    });
  }

  function boot() {
    initHeroReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme-Editor: bei Section-Reload erneut anwenden
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
  }
})();
